<template>
	<div id="container">
		<div class="banner">
			<Logout v-if="haslogin" style="float: right"></Logout>
			<Login v-else style="float: right"></Login>
		</div>
		
		<div class="otherground">
			<div class="margin">
				<div class="title">
					<span class="txt">游戏专区</span>
				</div>
				<div class="game_area">
					<ul class="tabs">
						<li @click="tab=1" :class="tab==1? 's': ''">闲来游戏</li>
						<div class="more" @click="tab==1?getmoregames_xl():getmoregames_hl()">more</div>
					</ul>
					<div class="game_content" v-show="tab==1">
						<ul>
                            <li>
								<router-link to="/download_gd">
									<img src="../../images/xianlaigame/xl_gd.png" />
									<div class="name">闲来广东麻将</div>
								</router-link>
							</li>
							<li>
								<router-link to="/download_gs">
									<img src="../../images/xianlaigame/xl_gansu.png" />
									<div class="name">闲来甘肃麻将</div>
								</router-link>
							</li>
							<li>
								<router-link to="/download_gz">
									<img src="../../images/xianlaigame/xl_gz.png" />
									<div class="name">闲来贵州麻将</div>
								</router-link>
							</li>
							<li>
								<router-link to="/download_fj">
									<img src="../../images/xianlaigame/xl_fj.png" />
									<div class="name">八闽福建麻将</div>
								</router-link>
							</li>
							<li>
								<router-link to="/download_gx">
									<img src="../../images/xianlaigame/xl_gx.png" />
									<div class="name">山水广西麻将</div>
								</router-link>
							</li>
						</ul>
						<ul>
							<li>
								<router-link to="/download_nx">
									<img src="../../images/xianlaigame/xl_nx.png" />
									<div class="name">闲来宁夏麻将</div>
								</router-link>
							</li>
							<li>
								<router-link to="/download_yn">
									<img src="../../images/xianlaigame/xl_yn.png" />
									<div class="name">山水云南麻将</div>
								</router-link>
							</li>
							<li>
								<router-link to="/download_hn">
									<img src="../../images/xianlaigame/xl_hn.png" />
									<div class="name">琼崖海南麻将</div>
								</router-link>
							</li>
							<li>
								<router-link to="/download_nm">
									<img src="../../images/xianlaigame/xl_nm.png" />
									<div class="name">龙腾内蒙麻将</div>
								</router-link>
							</li>
							<li>
								<router-link to="/download_sx">
									<img src="../../images/xianlaigame/xl_sx.png" />
									<div class="name">闲来陕西麻将</div>
								</router-link>
							</li>
						</ul>
					</div>
					<div class="game_content" v-show="tab==2">
						<ul>
							<li>
								<a href="http://wsjj.kunlun.com/">
									<img src="../../images/kunlun_game/kl_wsjj.png" />
									<div class="name">无双剑姬</div>
								</a>
							</li>
							<li>
								<a href="http://els.kunlun.com/">
									<img src="../../images/kunlun_game/kl_arjz.png" />
									<div class="name">艾尔战记</div>
								</a>
							</li>
							<li>
								<a href="http://coc.kunlun.com/">
									<img src="../../images/kunlun_game/kl_blct.png" />
									<div class="name">部落冲突</div>
								</a>
							</li>
							<li>
								<a href="http://bb.kunlun.com/">
									<img src="../../images/kunlun_game/kl_kdqb.png" />
									<div class="name">海岛骑兵</div>
								</a>
							</li>
							<li>
								<a href="https://cr.kunlun.com/">
									<img src="../../images/kunlun_game/kl_hszz.png" />
									<div class="name">皇室战争</div>
								</a>
							</li>
							<li>
								<a href="http://jhzr.kunlun.com/">
									<img src="../../images/kunlun_game/kl_jhzr.png" />
									<div class="name">剑魂之刃</div>
								</a>
							</li>
							<li>
								<a href="http://m3.kunlun.com/">
									<img src="../../images/kunlun_game/kl_msg.png" />
									<div class="name">梦三国</div>
								</a>
							</li>
							<li>
								<a href="http://hoc.kunlun.com/">
									<img src="../../images/kunlun_game/kl_smsy.png" />
									<div class="name">神魔圣域</div>
								</a>
							</li>
							<li>
								<a href="http://wxqz.kunlun.com/">
									<img src="../../images/kunlun_game/kl_wxqq.png" />
									<div class="name">武侠qq</div>
								</a>
							</li>
							<li>
								<a href="http://wxwz.kunlun.com/">
									<img src="../../images/kunlun_game/kl_wlwz.png" />
									<div class="name">武侠外传</div>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Login from '../../components/login/login.vue'
import Logout from '../../components/login/logout.vue'
// import Reg from '../../components/reg/reg.vue'
import { mapState } from 'vuex'

export default {
    data() {
        return {
            tab:1
        }
    },
    components:{
      Login,
      Logout,
    //   Reg
    },
    computed: mapState([
      'loginPage','haslogin','userData'
    ]),
    methods:{
        getmoregames_xl: function() {
            this.$router.push({
                name: 'gamecenter'
            });
        },
        changePage(game){
            // TODO:
            // if(!this.userData.gid){
            //     this.$alert("请先登录", '提示', {
            //         confirmButtonText: '确定',
            //         callback: action => {
            //             console.log(action);
            //             this.$router.push({path: '/home'});
            //         }
            //     });
            //     return false;
            // }
            // this.$ajaxUrls.appKey = this.$ajaxUrls.gamesKey[game];
            // window.sessionStorage.setItem("appKey",this.$ajaxUrls.gamesKey[game]);
            // this.$router.push({path: '/toGame?clientType=3'});
        }
    }
}
</script>

<style lang="scss" scoped>
	@import '../../components/style/mixin';
	#container{margin-top: -5px}
	.border_blue{border-bottom: 3px solid #1990FF;padding-bottom: 5px}
	.banner{background: url("../../images/middle_bg.png") no-repeat top 0 left 0 /100% 100%;height: 512px;padding-top: 75px;padding-right: 11%}
	@media screen and  (max-width: 1400px){
		.banner{height: 400px;padding-top:15px;padding-right: 5%}
	}
	.game_title{color: #333333;text-align: center;font-size: 42px;margin-top: 30px;margin-bottom: 30px;line-height: 50px;height: 50px;}
	.games{display: flex;justify-content: center;text-align: center}
	.games>div{width: 460px; padding-bottom: 16px;}
	.games_title{color: #333333;font-size: 24px;margin-bottom: 8px;margin-top: 5px}
	.games_inner{width: 360px;margin: 0 auto;color: #666666;text-align: left;}
	.games_img{width: 355px;height: 237px;}
	.reg_page{background-color: rgb(254,254,254)}
	.margin {
		padding-top: 30px;
		.title {
			position: relative;
			.txt {
				padding-left: 13px;
				font-weight: bold;
				@include sc(24px,
						#333333);
			}
		}
		.title:before {
			position: absolute;
			top: 4px;
			bottom: 1px;
			display: inline-block;
			content: '';
			height: 25px;
			border-left: 4px solid #ffdb17;
		}
	}
	.otherground {
		width: 100%;
		min-width: 1000px;
		background-color: #f0f0f0;
		.game_area {
			padding: 30px 0 50px;
			.tabs {
				position: relative;
				.more {
					position: absolute;
					bottom: 8px;
					right: 0px;
					border: 1px solid #666;
					padding: 0px 10px;
					line-height: 22px;
					@include borderRadius(5px);
					@include sc(14px,
							#666);
					cursor: pointer;
				}
				.more:hover {
					border: 1px solid #ffbb17;
					@include sc(14px,
							#ffbb17);
				}
				&>li {
					display: inline-block;
					padding: 5px 10px 6px;
					margin-right: 20px;
					@include sc(18px,
							#666);
					cursor: pointer;
					&.s {
						background-color: #ffbb17;
						@include borderRadius(20px);
						@include sc(18px,
								#fff);
					}
				}
			}
			.game_content {
				padding-top: 20px;
				font-size: 0;
				ul{display: flex;justify-content: space-between}
				ul>li {
					width: 120px;
					margin: 10px 56px 30px 0px;
					.name {
						width: 120px;
						line-height: 40px;
						text-align: center;
						@include sc(18px,
								#666666);
					}
                    img {
                        border-radius: 18px;
                    }
				}
			}
		}
	}
</style>
